<template>
  <h6 class="mb-0">{{ titlePage }}</h6>
  <p class="mb-0 text-sm">{{ subtitlePage }}</p>
  <hr class="my-3 horizontal dark" />
  <div class="row">
    <div class="col-8">
      <div class="form-group">
        <label for="email" class="form-label">Order Title</label>
        <input id="email" type="text" class="form-control" disabled :value="record.order_title" />
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label for="invoiceId" class="form-label">Invoice ID</label>
        <input id="fullName" type="text" class="form-control" disabled :value="record.id"/>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label for="invoiceId" class="form-label">Subscription ID</label>
        <input id="fullName" type="text" class="form-control" disabled :value="record.subscription_id"/>
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label for="email" class="form-label">Payment Amount</label>
        <input id="email" type="text" class="form-control" disabled :value="'Rp.' + record.payment_amount" />
      </div>
    </div>
    <div class="col-4">
      <div class="form-group">
        <label class="form-label">Customer Code</label>
        <input type="text" class="form-control" disabled :value="record.customer_code"/>
      </div>
    </div>
    <div class="col-4" v-if="getProofOfPayment()">
      <div class="form-group" >
        <label class="form-label mr-3">Proof of Payment</label>
        <br />
        <a href="#" class="btn btn-primary btn-xs" @click="getProofOfPaymentUrl()"> Open </a>
      </div>
    </div>
     <div class="col-4" v-if="record.order_product_type === 'education'">
      <div class="form-group">
        <label class="form-label">Phone Number</label>
        <input type="text" class="form-control" disabled :value="record.phone_number"/>
      </div>
    </div>
     <div class="col-4" v-if="record.order_product_type === 'education'">
      <div class="form-group">
        <label class="form-label">Meta Account Number</label>
        <input type="text" class="form-control" disabled :value="record.meta_account_number||'-'"/>
      </div>
    </div>


    <div class="row" v-if="record.document_service_agreement != null && record.status == 'paid'">
      <hr class="my-3 horizontal dark" />
      <div class="col-8">
        <div class="form-group">
          <label class="form-label mr-3">Agreement Document</label>
          <br />
          <a :href="record.document_service_agreement" class="btn btn-primary btn-xs" target="_blank"> Open Service Agreement </a>
          <br />
          <a :href="record.document_notice_of_risk" class="btn btn-primary btn-xs" target="_blank"> Open Notice Of Risk </a>
          <br />
          <a :href="record.document_letter_of_statement" class="btn btn-primary btn-xs" target="_blank"> Open Letter Of Statement</a>
        </div>
      </div>

    </div>
  
    <div class="row" v-if="record != null">
      <hr class="my-3 horizontal dark" />

      <div class="col-4" v-if="record.margin?.margin_in">
        <div class="form-group">
          <label class="form-label">Margin In</label>
          <input type="text" class="form-control" disabled :value="record.margin.margin_in"/>
        </div>
      </div>
      <div class="col-4" v-if="record.margin?.target_profit">
        <div class="form-group">
          <label class="form-label">Target Profit</label>
          <input type="text" class="form-control" disabled :value="record.margin.target_profit"/>
        </div>
      </div>
      <div class="col-4" v-if="additionalData['outstanding_in']">
        <div class="form-group">
          <label class="form-label">Outstanding In %</label>
          <input type="text" class="form-control" disabled :value="additionalData['outstanding_in']"/>
        </div>
      </div>
      <div class="col-4" v-if="record.margin?.rate">
        <div class="form-group" >
          <label class="form-label">Rate</label>
          <input type="text" class="form-control" disabled :value="record.margin.rate"/>
        </div>
      </div>
      <div class="col-4" v-if="record.margin?.sas_fee">
        <div class="form-group">
          <label class="form-label">Sas Fee</label>
          <input type="text" class="form-control" disabled :value="record.margin.sas_fee"/>
        </div>
      </div>
      <div class="col-4" v-if="additionalData['base_price']">
        <div class="form-group">
          <label class="form-label">Base Price</label>
          <input type="text" class="form-control" disabled :value="additionalData['base_price']"/>
        </div>
      </div>

      <div class="col-4">
        <div class="form-group">
          <label class="form-label">Total Payment</label>
          <input type="text" class="form-control" disabled :value="record['payment_amount']"/>
        </div>
      </div>
      <hr class="my-3 horizontal dark" />

    </div>
  
    
    <div class="col-12">
      <div class="form-group">
        <label  class="form-label">Additional Data</label>
        <VueJsonView :src="record.additional_param" />
      </div>
    </div>    
  </div>
  
  
  <hr class="my-3 horizontal dark" />
  
  <div v-if="record.status == 'waiting_confirmation' && getProofOfPayment()" class="mt-4 d-flex justify-content-end">
    <a @click.prevent="$emit('cancel')" class="m-0 btn btn-light">
      Cancel
    </a>
    <button
    type="button"
    name="button"
    class="m-0 btn bg-gradient-success ms-2"
    @click="confirmationApprove()"
    
    >
    Approve
  </button>
  <button
    type="button"
    name="button"
    class="m-0 btn bg-gradient-danger ms-2"
    @click="confirmationReject()"
    
    >
    Reject
  </button>
</div>
</template>

<script>
import showPopupReject from "@/mixins/showSwal.js";
import showPopupApprove from "@/mixins/showSwal.js";
import VueJsonView from '@matpool/vue-json-view'
import FilesService from "@/services/files.service.js";

export default {
  data() {
    return {
      statuses: ['active', 'waiting_confirmation', 'declined'],
      record: {},
      additionalData: {},
    };
  },
  setup: () => {
      const options = {modules: {toolbar: false}, readOnly: true}
      return { options }
    },
  components: {
    VueJsonView
  },    
  props: {
    titlePage: String,
    subtitlePage: String,
    submitButtonName: String,
    onSubmit: { type: Function },
    toggleModal: { type: Function },
    recordProps: { type: Object }
  },
  watch: {
    recordProps: function (newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.record = newVal

      if(this.record != null && this.record != undefined) {
        this.additionalData = JSON.parse(this.record.additional_param)
      }
    },
  },
  mixins: [showPopupReject, showPopupApprove],
  methods: {
    getProofOfPayment() {
      return this.record != null && this.record.additional_param && JSON.parse(this.record.additional_param).proof_payment
    },
    getProofOfPaymentUrl() {
      console.log(this.getProofOfPayment())
      FilesService.get(this.getProofOfPayment()).then(e => {
        // this.record = e.data.invoice_data
        // this.hideLoading()
        window.open(e.data.file_url, '_blank')
        console.log(e)
      }).catch(e => {
        console.log(e)
        // this.showFailed(e.response.data.code_message)           
      });
    },
    confirmationReject(){
      this.showPopupReject().then((result) => {
          if (result.value) {
            const params = {
              status: 'declined'
            }
            this.onSubmit(params)
          }
        });        
    },
    confirmationApprove(){
      this.showPopupApprove().then((result) => {
          if (result.value) {
            const params = {
              status: 'paid'
            }
            this.onSubmit(params)
          }
        });        
    },
    updateTradingBalance(){
      const params = {
        balance: this.record.balance
      }
      // console.log(params)
      this.onSubmit(params)
    }
  }
}
</script>
